(function () {
  if (!customElements.get('complete-look-slider')) {
    class CompleteLookSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-complete-look-track]');
        this.cards = Array.from(this.querySelectorAll('.product-upsell'));
        if (!this.track || this.cards.length < 2) return;

        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          var direction = event.key === 'ArrowRight' ? 1 : -1;
          this.track.scrollBy({ left: direction * this.cardStep(), behavior: 'smooth' });
        });
      }

      cardStep() {
        var card = this.cards[0];
        var styles = getComputedStyle(this.track);
        return card.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 0);
      }
    }

    customElements.define('complete-look-slider', CompleteLookSlider);
  }

  if (!customElements.get('product-upsell')) {
    class ProductUpsell extends HTMLElement {
      connectedCallback() {
        if (this.dataset.upsellReady === 'true') return;
        this.dataset.upsellReady = 'true';

        this.variants = this.readVariants();
        this.sizeButtons = Array.from(this.querySelectorAll('[data-upsell-variant]'));
        this.button = this.querySelector('.product-upsell__button');
        this.buttonLabel = this.querySelector('[data-upsell-button-label]');
        this.price = this.querySelector('[data-upsell-price]');
        this.comparePrice = this.querySelector('[data-upsell-compare]');
        this.image = this.querySelector('[data-upsell-image]');
        this.error = this.querySelector('[data-upsell-error]');
        this.currentVariant = this.variantById(this.dataset.selectedVariant) || this.variants.find((variant) => variant.available) || null;

        this.sizeButtons.forEach((button) => {
          button.addEventListener('click', () => this.selectVariant(button.dataset.upsellVariant));
        });
        this.button?.addEventListener('click', (event) => this.addToCart(event));
        this.renderVariant();
      }

      readVariants() {
        var script = this.querySelector('[data-upsell-variants]');
        if (!script) return [];
        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.error('Complete The Look variant data is invalid.', error);
          return [];
        }
      }

      variantById(id) {
        return this.variants.find((variant) => String(variant.id) === String(id));
      }

      selectVariant(id) {
        var variant = this.variantById(id);
        if (!variant || !variant.available) return;
        this.currentVariant = variant;
        this.dataset.selectedVariant = variant.id;
        this.renderVariant();
      }

      renderVariant() {
        var variant = this.currentVariant;
        var available = Boolean(variant && variant.available);

        this.sizeButtons.forEach((button) => {
          var selected = Boolean(variant && String(button.dataset.upsellVariant) === String(variant.id));
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        if (this.button) this.button.disabled = !available;
        if (this.buttonLabel) this.buttonLabel.textContent = available ? this.dataset.labelAdd : this.dataset.labelUnavailable;
        if (!variant) return;

        if (this.price) this.price.textContent = this.formatMoney(variant.price);
        var hasComparePrice = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        if (this.comparePrice) {
          this.comparePrice.textContent = hasComparePrice ? this.formatMoney(variant.compare_at_price) : '';
          this.comparePrice.classList.toggle('is-hidden', !hasComparePrice);
        }

        var variantImage = variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
        if (this.image && variantImage) this.image.src = variantImage;
        this.clearError();
      }

      formatMoney(cents) {
        var currency = window.Shopify?.currency?.active || 'EUR';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: currency }).format(Number(cents || 0) / 100);
        } catch (error) {
          return '€' + (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
        }
      }

      clearError() {
        if (!this.error) return;
        this.error.hidden = true;
        this.error.textContent = '';
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message || this.dataset.labelError;
        this.error.hidden = false;
      }

      async addToCart(event) {
        event.preventDefault();
        var variant = this.currentVariant;
        if (!variant || !variant.available || this.button?.getAttribute('aria-busy') === 'true') return;

        this.clearError();
        this.button?.setAttribute('aria-busy', 'true');
        if (this.button) this.button.disabled = true;

        var formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', '1');
        formData.append('sections', 'variant-added');
        formData.append('sections_url', window.location.pathname);

        try {
          var response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          var responseJson = await response.json();
          if (!response.ok) throw new Error(responseJson.description || responseJson.message);

          var cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then((result) => result.json());
          cart.sections = responseJson.sections;
          this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: responseJson.items || [responseJson], cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          this.showError(error.message);
          this.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: error.message } }));
        } finally {
          this.button?.removeAttribute('aria-busy');
          if (this.button) this.button.disabled = !this.currentVariant?.available;
        }
      }
    }

    customElements.define('product-upsell', ProductUpsell);
  }
})();
